// import Vue from 'vue'
import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextPage";
import axios from "axios";

@Component({})
export default class configurationPage extends baseUserContextPage {
  isLoading: boolean = false;

  get breadcrumbsLabel(): string { 
    return this.$route.name == 'configurationFiltriCategorie' ? 'Filtri Categorie' : 'Import';
  }
  fetch(): void {

  }
  mounted() {
    var instance = this;

    // instance.fetch();
  }
}